import type { SolutionUserPresenceItem } from '../xstate/prostudio.xstate.types';

/** The two routes that render the editable node table. */
export function isTablePage(path: string): boolean {
  return path.includes('/workflows') || path.includes('/actions');
}

/**
 * PSTUDIO-3929 (b): the coworker-focus subscription is the ONLY cross-machine
 * live sync path. It used to open only while another user held a *focused
 * cell* on the same page, so a teammate who merely ADDED a node (without
 * keeping a cell focused) never pushed the new row — the receiver had to
 * reload manually. Gate on the weaker "another active user is on this same
 * table page" instead, so a newly added node propagates in near-real-time.
 *
 * `focusedCell` is still consumed by `getFocusSignature` to decide WHEN to
 * re-run validation on an incoming merge — only the SUBSCRIBE gate is widened
 * here, never the validation-trigger signature.
 */
export function hasOtherActiveUserOnPage(
  presences: SolutionUserPresenceItem[] | undefined,
  pathname: string,
  currentUserId: string
): boolean {
  if (!isTablePage(pathname)) return false;
  return (presences ?? []).some(
    (p) =>
      String(p.userId ?? p.user?.id ?? '') !== currentUserId &&
      Boolean(p.isActive && p.pagePath === pathname)
  );
}
